import { AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface ErrorStateProps {
  title: string
  description: string
  testId: string
  onRetry?: () => void
  isRetrying?: boolean
  children?: React.ReactNode
}

export function ErrorState({ title, description, testId, onRetry, isRetrying = false, children }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed py-16" role="alert" data-testid={testId}>
      <AlertCircle className="h-12 w-12 text-destructive" />
      <h3 className="mt-4 text-lg font-semibold">{title}</h3>
      <p className="mt-1 max-w-md text-center text-sm text-muted-foreground">{description}</p>
      {(onRetry || children) && (
        <div className="mt-4 flex items-center gap-2">
          {onRetry && (
            <Button onClick={onRetry} variant="outline" disabled={isRetrying}>
              {isRetrying ? 'Retrying...' : 'Try Again'}
            </Button>
          )}
          {children}
        </div>
      )}
    </div>
  )
}
